let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1Ww9d")).then(() => parcelRequire('4vsJb'));